import React, { useEffect, useState } from "react";
import TableQuickselect, { AvatarCell, SelectColumnFilter, StatusPill, ImageCell,ProductCell  } from "./TableQuickselect"; // new

function TableDataQuickselect() {
  const data = [
    {
      status: "Return",
      c_name: "Bulbs",
      id: "#1345cdvbd",
      schedule: "warehouse 1",
      deadline:"25-oct-2022",

    },
    {
      status: "",
      c_name: "Cambo",
      id: "#23232cbedf",
      schedule: "warehouse 1",
      deadline:"25-oct-2022",

    },
    {
      status: "Return",
      c_name: "Avon Bulbs",
      id: "#334434erer",
      schedule: "warehouse 1",
      deadline:"25-oct-2022",

    },
    {
      status: "",
      c_name: "Broardleight Bulbs",
      id: "#43454fcedfd",
      schedule: "warehouse 1",
      deadline:"25-oct-2022",

    },
  ];

  const columns = React.useMemo(
    () => [

      {
        Header: "JOB ID",
        accessor: "id",
      },
     
      {
        Header: "Customer",
        accessor: "c_name",
      },
    
      {
        Header: "Schedule Name",
        accessor: "schedule",
      },
      {
        Header: "Deadline",
        accessor: "deadline",
       
       
      },
     
      {
        Header: "Status",
        accessor: "status",
        Cell: ProductCell,
      },
    
    ],
    []
  );

  return (
    <div className="mb-8 pb-4">
      <main className="max-w-full min-h-full px-4 sm:px-6 lg:px-8 pt-4">
        <div className="-mt-10">
          <TableQuickselect
            columns={columns}
            data={data == undefined ? [] : data}
            text="Undefined"
          />
        </div>
      </main>
    </div>
  );
}

export default TableDataQuickselect;
